var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgContestCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 84,
    viewBox: "0 0 96 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-contest-card"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 84,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg-contest-card)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.58,6.96C78.667-1.26,66.18-.315,56.566.559,41.455,1.943,40.793,2.313,25.786,4.706,5,8.02-.012,20.765,0,40.3.008,51.724,3.07,64.164,13.728,69.965c8.88,8.332,30.737,6.011,43.782,5.441,17.129-.75,34.142-6.423,37.519-25.482C97.707,34.849,93.2,16.015,85.58,6.96",
    transform: "translate(0 -0.001)",
    fill: "#428c96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.609,236.8a13.715,13.715,0,0,0,7.021,11.661s-14.606,1.61-18.2-8.478Z",
    transform: "translate(-89.625 -164.73)",
    fill: "#428c96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.369 15.622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.629,132.339A23.534,23.534,0,1,1,242.1,108.8a23.534,23.534,0,0,1,23.534,23.534",
    transform: "translate(-218.561 -108.805)",
    fill: "#ffcf4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.456,157.568l5.92,13.8a2.432,2.432,0,0,0,4.6-1.518l-3.484-14.75a1.908,1.908,0,0,0-2.522-1.35l-3.427,1.274a1.908,1.908,0,0,0-1.089,2.541",
    transform: "translate(-309.326 -146.924)",
    fill: "#428c96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.758,301.971a3.658,3.658,0,1,1-3.736-3.579,3.658,3.658,0,0,1,3.736,3.579",
    transform: "translate(-353.664 -270.019)",
    fill: "#428c96"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgContestCard);
export default __webpack_public_path__ + "static/media/bg-contest-card.8781794a1eb19ce93535f30acd4cd318.svg";
export { ForwardRef as ReactComponent };